import { useDataValue, useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let email = useDataValue({
    context: 'email',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'edit_email',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.email = email.email
      next.id = email.id
    })
  }
}

export function getView(id) {
  return id !== null
}
